<template>
  <div>
    <v-simple-table class="table-layout pa-5 pb-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th>Nhân viên</th>
            <th class="fix-width">Đơn hàng</th>
            <th>Doanh thu khởi tạo</th>
            <th>ARPU khởi tạo</th>
            <th>Giao hàng thành công (%)</th>
            <th>Doanh thu thành công</th>
            <th>Cập nhật lần cuối</th>
            <th>ARPU thành công</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="employeeReports.length">
            <td class="total-text">Tổng</td>
            <td class="total-text fix-width">{{ totalReports.initNoNumber }}</td>
            <td class="total-text">
              <span v-if="totalReports.initTurnOver !== null">{{ formatPrice(parseFloat(totalReports.initTurnOver)) }}</span>
              <span v-else>0</span>
            </td>
            <td class="total-text">
              <span v-if="totalReports.initArpu !== null">{{ formatPrice(parseFloat(totalReports.initArpu)) }}</span>
              <span v-else>0</span>
            </td>
            <td class="total-text">{{ totalReports.successRatio + '%' }}</td>
            <td class="total-text">
              <span v-if="totalReports.successTurnOver !== null">{{ formatPrice(totalReports.successTurnOver) }}</span>
              <span v-else>0</span>
            </td>
            <td></td>
            <td class="total-text">
              <span v-if="totalReports.successArpu !== null">{{ formatPrice(parseFloat(totalReports.successArpu)) }}</span>
              <span v-else>0</span>
            </td>
          </tr>
          <template v-for="employeeReport in employeeReports">
            <tr
              :key="employeeReport.id"
            >
              <td>{{ employeeReport.fullName }}</td>
              <td class="fix-width">{{ employeeReport.initNoNumber }}</td>
              <td>
                <span v-if="employeeReport.initTurnOver !== null">{{ formatPrice(parseFloat(employeeReport.initTurnOver)) }}</span>
                <span v-else>0</span>
              </td>
              <td>
                <span v-if="employeeReport.initArpu !== null">{{ formatPrice(parseFloat(employeeReport.initArpu)) }}</span>
                <span v-else>0</span>
              </td>
              <td>{{ employeeReport.successRatio + '%' }}</td>
              <td>
                <span v-if="employeeReport.successTurnOver !== null">{{ formatPrice(employeeReport.successTurnOver) }}</span>
                <span v-else>0</span>
              </td>
              <td></td>
              <td>
                <span v-if="employeeReport.successArpu !== null">{{ formatPrice(parseFloat(employeeReport.successArpu)) }}</span>
                <span v-else>0</span>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>

  </div>
</template>
<script>

import { formatPrice } from '@/helpers/utils'
  export default {
    components: {},
    props: {
      employeeReports: {
        type: Array,
        default: () => []
      },
      totalReports: {
        type: Object,
        default: () => {}
      },
      roleName: {
        type: String,
        default: ''
      },
    },
    created () {

    },
    computed: {

    },
    methods: {
      averageCallDuration(totalDurationSuccess, totalCallSuccess) {
        if (totalCallSuccess == 0 || totalDurationSuccess == 0) {
          return 0
        } else {
          return +((totalDurationSuccess / totalCallSuccess) / 60).toFixed(2)
        }
      }
    },
  }
</script>
<style scoped>
.total-text {
  color: #ff5252;
}
.fix-width {
  width: 70px !important;
}
.table-layout table thead tr th {
  font-size: 13px !important;
  min-width: 70px !important;
}
</style>